import { useBankAccounts } from "../../../services/cashier";
import { useEffect, useState } from "react";

const BankAccountDropDown = function ({ bankSet }) {
  const [amount, setAmount] = useState();
  const bankAccounts = useBankAccounts();

  useEffect(() => {
    bankSet(null);
    return () => bankSet(null);
  }, []);
  console.log("Bank Accounts:", bankAccounts?.data);
  return (
    <div class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6">
      <label for="exampleFormControlInput1" class="cashierNewTitel">
        Bank Accounts
        {amount}
      </label>
      <select
        onChange={(e) => {
          if (String(e.target.value) === "0") {
            bankSet(null);
            return;
          }

          try {
            const parsed = JSON.parse(e.target.value);
            bankSet(parsed);
          } catch (error) {
            // Fallback: treat as id-only
            bankSet({ id: e.target.value });
          }
        }}
        class="form-select"
        aria-label="Default select example"
        name="bankAccount"
      >
        <option value="0">-Select-</option>
        {bankAccounts?.data?.map((bankacc) => (
          <option
            value={JSON.stringify({
              id: bankacc["id"],
              accNumber: bankacc["acc_number"],
            })}
            key={"bankdrop" + bankacc["id"]}
          >
            {bankacc["bank_name"]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BankAccountDropDown;
